<template>
  <div>
    <v-dialog v-model="dialog"
              scrollable
              width="900"
    >
      <v-card>

        <v-card-title>
          Détails du point de vente
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-8">
          <v-simple-table class="table-border rounded-lg">
            <template v-slot:default>
              <tbody>
              <tr>
                <th>Nom complet</th>
                <td> {{ salepoint.salepoint?.pos_name }}</td>
              </tr>
              <tr>
                <th>Téléphone</th>
                <td>{{ salepoint.salepoint?.owner_phone }}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>
                  <v-chip color="white" text-color="gifty">
                    <v-icon left small>mdi-tag</v-icon>
                    {{ salepoint.salepoint?.salepoint_type?.name }}
                  </v-chip>
                </td>
              </tr>
              <tr>
                <th>Wilaya</th>
                <td>{{ salepoint.salepoint?.wilaya?.name }}</td>
              </tr>
              <tr>
                <th>Commune</th>
                <td>{{ salepoint.salepoint?.commune?.name }}</td>
              </tr>
              <tr>
                <th>Adresse</th>
                <td>{{ salepoint.salepoint?.adress }}</td>
              </tr>
              <tr>
                <th>Numéro d'enregistrement commercial</th>
                <td>{{ salepoint.commercial_registration_number }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table class="table-border rounded-lg mt-3">
            <template v-slot:default>
              <tbody>
              <tr>
                <th>Photos du magasin</th>
                <td>
                  <v-row class="pa-4">
                    <v-col cols="3" v-for="(image,imgIndex) in salepoint.store_photos" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,salepoint.store_photos)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </td>
              </tr>

              <tr>
                <th>Photos d'autocollants GIFTY</th>
                <td>
                  <v-row class="pa-4">
                    <v-col cols="3" v-for="(image,imgIndex) in salepoint.gifty_stickers_photos" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,salepoint.gifty_stickers_photos)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>


        </v-card-text>
      </v-card>

      <vue-easy-lightbox escDisabled
                         moveDisabled
                         :visible="visible"
                         :imgs="lightboxImage"
                         :index="index"
                         @hide="visible = false"></vue-easy-lightbox>

    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      salepoint: {},

      /**Lightbox**/
      FILE_URL: process.env.VUE_APP_FILE_URL,
      lightboxImage: "",
      visible: false,
      index: 0,
    }
  },
  methods: {
    open(item) {
      this.dialog = true
      this.salepoint = item
    },
    close() {
      this.dialog = false
    },
    showLightbox(index, imgs) {
      if (imgs && imgs.length) {
        this.lightboxImage = imgs.map((img) => {
          return {src: this.FILE_URL + img}
        });
        this.index = index;
        this.visible = true;
      }
    },
  },
}
</script>

